export default __webpack_public_path__ + "static/media/realitybytes_l.56cdf330.jpg";